import * as React from 'react';
import { connect } from 'react-redux';
import { __, __r } from 'react-i18n';
import {
  BreadCrumbType,
  setBreadCrumbPath,
} from '../BreadCrumb/breadCrumbSlice';
import {
  loadcomparisonProductsData,
  resetProductsData,
} from './comparisonSlice';
import { CompareFixedBottom } from 'eshop-defaults';
import SliderComponent from '../../components/_helpers/Slider/Slider';
import { CompareService } from 'eshop-defaults';

interface Props {
  dispatch: any;
  products: any[];
  isFetching: boolean;
  pathBeforeTransition: string;
}

function CompareFixedBottomContainer({
  products,
  dispatch,
  isFetching,
  pathBeforeTransition,
}: Props) {
  React.useEffect(() => {
    const compareService = new CompareService();
    dispatch(
      loadcomparisonProductsData(compareService.getCompareProductIds(), false),
    );
  }, [dispatch]);

  const resetAll = () => {
    const compareService = new CompareService();
    compareService.removeAll();
    dispatch(resetProductsData());
  };

  const productRemove = (productId: number) => {
    const compareService = new CompareService();
    const productIds = compareService.removeProductToCompare(productId);

    if (productIds.length) {
      dispatch(loadcomparisonProductsData(productIds, false));
    } else {
      dispatch(resetProductsData());
    }
  };

  React.useEffect(() => {}, [pathBeforeTransition]);

  return (
    <>
      {window?.location?.pathname !== __r('routes:porovnanie', '/porovnanie') &&
      products?.length ? (
        <CompareFixedBottom
          products={products}
          onReset={resetAll}
          isFetching={isFetching}
          sliderComponent={
            <SliderComponent
              type="compare"
              slides={products}
              productRemove={productRemove}
            />
          }
        />
      ) : (
        <></>
      )}
    </>
  );
}

const mapStateToProps = state => {
  return {
    products: state.comparison?.products,
    isFetching: state.comparison?.isFetching,
    pathBeforeTransition: state.routing?.locationBeforeTransitions?.pathname,
  };
};

export default connect(mapStateToProps)(CompareFixedBottomContainer);
